// @ts-nocheck

const ReactDOM = require('react-dom/index')

Object.assign(window.ReactDOM, ReactDOM)

window.ReactDomLoadedResolve()
